import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../../../styles/agentRecharge.scss'
import ModalHeader from '../../common/Header'
import { useDispatch, useSelector } from 'react-redux'
import DropDownV3 from '../../common/DropDownV3'
import dayjs from 'dayjs'
import TextBox from '../../common/TextBox'
import CustomDatePicker from '../../common/CustomDatePicker'
import MButton from '../../common/MButton'
import MultiSelectDropDown from '../../common/MultiSelectDropdown'
import { isEmpty } from '../../../Utils'
import { getAgentList, getPaymentMode, updateAgentRecharges, updateShowAlert } from '../../../redux/Actions'
const AgentRecharge = () => {
    const { agentList, userDetails, paymentMode } = useSelector((state) => state.common);
    const dispatch = useDispatch()
    const [filterValue, setFilterValue] = useState({
        agentCity: [],
        agentName: [],
        paymentMode: [],
        amount: '',
        bankName: '',
        transactionId: '',
        transDate: dayjs(new Date())
    })
    const [filterOpt, setFilterOpt] = useState({
        agentName: [],
    })

    useEffect(() => {
        if (!isEmpty(userDetails)) {
            fetchData()
        }
    }, [userDetails.CompanyID])

    const fetchData = () => {
        const bodyAgent = {
            intUserID: userDetails?.UserID,
            intCompanyID: userDetails?.CompanyID,
        };
        const paymentBody = {
            intAgentID: userDetails?.AgentID,
            strKeyCode: '',
            intUserID: userDetails?.UserID
        }

        Promise.all([
            dispatch(getAgentList(bodyAgent)),
            dispatch(getPaymentMode(paymentBody))
        ])
    }
    useEffect(() => {
        let filterAgent = agentList.filter((obj) => obj.CityID === userDetails?.BranchCityID)
        if (filterAgent.length === 0) {
            filterAgent = agentList.filter((obj) => obj.CityID === agentList?.[0]?.CityID)
        }
        setFilterValue((prev) => ({
            ...prev,
            agentCity: filterAgent?.length > 0 ? [filterAgent[0]] : []
        }))
        setFilterOpt((prev) => ({
            ...prev,
            agentName: filterAgent
        }))
    }, [agentList])

    useEffect(() => {
        setFilterValue((prev) => ({
            ...prev,
            paymentMode: paymentMode?.length > 0 ? [paymentMode[0]] : []
        }))
    }, [paymentMode])


    const paymentModeProps = () => {
        return {
            id: 'paymentMode',
            width: "100%",
            name: "Payment Mode",
            label: "Payment Mode",
            isCompulsory: false,
            options: paymentMode || [],
            preSelectedValues: filterValue?.paymentMode || [],
            searchPlaceholder: "Search Payment Mode",
            isObject: true,
            primaryKey: "PaymentId",
            labelKey: "PaymentName",
            singleSelect: true,
            disabled: false,
        };
    }
    const handleInputField = (event) => {
        setFilterValue((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }))
    }
    const handleAgentCity = (val) => {
        let filterAgent = []
        if (val?.length > 0) {
            filterAgent = agentList.filter((obj) => obj.CityID === val?.[0]?.CityID)
        }
        setFilterOpt((prev) => ({ ...prev, agentName: filterAgent }))
        setFilterValue((prev) => ({ ...prev, agentCity: val, agentName: [] }))
    }

    const handleSubmit = () => {
        if (filterValue?.agentCity?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Agent City!',
                open: true,
            }));
        } else if (filterValue?.agentName?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Agent Name!',
                open: true,
            }));
        } else if (filterValue?.paymentMode?.length === 0) {
            dispatch(updateShowAlert({
                msg: 'Select Payment Mode!',
                open: true,
            }));
        } else if (filterValue?.amount?.toString()?.trim() === '') {
            dispatch(updateShowAlert({
                msg: 'Please Enter Amount',
                open: true,
            }));
        } else if (filterValue?.bankName?.trim() === '') {
            dispatch(updateShowAlert({
                msg: 'Please Enter Bank Name',
                open: true,
            }));
        } else if (filterValue?.transactionId?.trim() === '') {
            dispatch(updateShowAlert({
                msg: 'Please Enter Transaction ID',
                open: true,
            }));
        } else {
            const body = {
                intAgentID: userDetails?.AgentID,
                strKeyCode: "",
                intUserID: userDetails?.UserID,
                intCompanyID: userDetails?.CompanyID,
                intRCAgentID: filterValue?.agentName?.[0]?.AgentID,
                dcmAmount: filterValue?.amount,
                intRechargePaymentModeID: filterValue?.paymentMode?.[0]?.PaymentId,
                strBankName: filterValue?.bankName,
                strInstrumentNo: filterValue?.transactionId,
                dtInstrumentDate: dayjs(filterValue?.transDate).format("YYYY-MM-DD")
            }
            dispatch(updateAgentRecharges(body)).then((res) => {
                if (res?.data?.APIAgentRechargesInsertResult.IsSuccess) {
                    dispatch(updateShowAlert({
                        msg: 'Successfully Recharge !',
                        open: true,
                    }));
                    setFilterValue((prev) => ({
                        ...prev,
                        agentName: [],
                        paymentMode: paymentMode?.length > 0 ? [paymentMode[0]] : [],
                        amount: '',
                        bankName: '',
                        transactionId: '',
                        transDate: dayjs(new Date())
                    }))
                } else {
                    dispatch(updateShowAlert({
                        msg: res?.data?.APIAgentRechargesInsertResult.ErrorMessage,
                        open: true,
                    }));
                }
            })
        }
    }
    return (
        <Box className='agentRecharge'>
            <ModalHeader headerText={"Agent Recharge"} showHamburger={true} />
            <Box className='filter-section'>
                <Box sx={{ width: '100%' }}>
                    <DropDownV3
                        label='Agent City'
                        option={agentList || []}
                        primaryKey='CityID'
                        labelKey='CityName'
                        preSelectedValues={filterValue?.agentCity || []}
                        onSelect={handleAgentCity}
                    />
                </Box>
                <Box sx={{ width: '100%' }}>
                    <DropDownV3
                        label='Agent Name'
                        option={filterOpt?.agentName || []}
                        primaryKey='AgentID'
                        labelKey='AgentName'
                        preSelectedValues={filterValue?.agentName || []}
                        onSelect={(val) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                agentName: val
                            }))
                        }}
                    />
                </Box>
                <Box sx={{ width: '100%' }}>
                    <MultiSelectDropDown
                        {...paymentModeProps()}
                        onSelect={(val) => {
                            setFilterValue((prev) => ({ ...prev, paymentMode: val }))
                        }} />
                </Box>
                <TextBox type='number' label="Amount" value={filterValue?.amount} name='amount' onChange={handleInputField} />
                <TextBox type='text' label="Bank Name" value={filterValue?.bankName} name='bankName' onChange={handleInputField} />
                <TextBox type='text' label="Transaction Id" value={filterValue?.transactionId} name='transactionId' onChange={handleInputField} />
                <Box className='AgentDatePicker'>
                    <CustomDatePicker
                        selectedDate={filterValue?.transDate}
                        label='Transaction Date'
                        format='DD-MMM-YYYY'
                        onChange={(val) => {
                            setFilterValue((prev) => ({
                                ...prev,
                                transDate: val
                            }))
                        }}
                        style={{ width: '100%' }}
                    />
                </Box>
                <Box>
                    <MButton btnName='submit' onClick={handleSubmit} />
                </Box>
            </Box>

        </Box>
    )
}

export default AgentRecharge